import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const SubscriptionTierIndicator = ({ 
  tier = 'pro', 
  showUpgrade = false, 
  className = '' 
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const tierConfig = {
    free: {
      label: 'Free',
      color: 'bg-muted text-text-secondary',
      icon: 'User',
      description: 'Basic crane search and valuation',
      limits: ['5 searches per day', 'Basic reports', 'Limited comparisons']
    },
    pro: {
      label: 'Pro',
      color: 'bg-success text-success-foreground',
      icon: 'Crown',
      description: 'Advanced features for dealers',
      limits: ['Unlimited searches', 'Detailed reports', 'Advanced comparisons', 'Inventory management']
    },
    enterprise: {
      label: 'Enterprise',
      color: 'bg-primary text-primary-foreground',
      icon: 'Building',
      description: 'Full platform access for institutions',
      limits: ['All Pro features', 'Portfolio management', 'API access', 'Custom integrations']
    }
  };

  const currentTier = tierConfig?.[tier] || tierConfig?.free;

  const handleUpgrade = () => {
    window.location.href = '/account-settings?tab=subscription';
  };

  return (
    <div className={`relative ${className}`}>
      <div 
        className="flex items-center space-x-2 cursor-pointer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div className={`flex items-center space-x-2 px-3 py-1.5 rounded-full text-xs font-medium ${currentTier?.color}`}>
          <Icon name={currentTier?.icon} size={12} />
          <span>{currentTier?.label}</span>
        </div>
        
        {showUpgrade && tier === 'free' && (
          <Button
            variant="outline"
            size="xs"
            onClick={handleUpgrade}
            iconName="ArrowUp"
            iconPosition="left"
            className="text-xs"
          >
            Upgrade
          </Button>
        )}
      </div>
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-2 w-64 bg-popover border border-border rounded-md shadow-dropdown z-300 p-4">
          <div className="space-y-3">
            <div>
              <h4 className="font-medium text-text-primary flex items-center space-x-2">
                <Icon name={currentTier?.icon} size={16} />
                <span>{currentTier?.label} Plan</span>
              </h4>
              <p className="text-sm text-text-secondary mt-1">{currentTier?.description}</p>
            </div>
            
            <div>
              <h5 className="text-sm font-medium text-text-primary mb-2">Features:</h5>
              <ul className="space-y-1">
                {currentTier?.limits?.map((limit, index) => (
                  <li key={index} className="flex items-center space-x-2 text-sm text-text-secondary">
                    <Icon name="Check" size={12} className="text-success" />
                    <span>{limit}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {tier === 'free' && (
              <Button
                variant="default"
                size="sm"
                onClick={handleUpgrade}
                iconName="ArrowUp"
                iconPosition="left"
                fullWidth
              >
                Upgrade Plan
              </Button>
            )}
          </div>
          
          {/* Tooltip Arrow */}
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-border"></div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionTierIndicator;